/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable unused-imports/no-unused-vars */
import React, { lazy, Suspense } from 'react';

import Modal from '@/components/modal/modal';
import Typography from '@/components/typography/typography';
import Button from '@/components/button/button';
import Select from '@/components/select/select';

import {
	Box,
	DialogActions,
	DialogContent,
	DialogProps,
	DialogTitle,
	IconButton,
	MenuItem
} from '@mui/material';
import Close from '@mui/icons-material/Close';

import './edit-section-modal.scss';
import { IEmail } from '../utils/types';
const CustomEditor = lazy(() => import('@/components/editor/custom-editor'));
import { SectionData } from '../types/editor';

interface EditSectionModalProps {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	modalProps: DialogProps;
	section: SectionData;
	placeholders: Record<string, any>[];
	handleSave: (e: any) => void;
	handleAddPlaceholder: (placeholder: string) => void;
	handleEditorReady: (placeholder: string) => void;
}

const EditSectionModal: React.FC<EditSectionModalProps> = ({
	isOpen,
	setIsOpen,
	modalProps,
	section,
	placeholders,
	handleSave,
	handleAddPlaceholder,
	handleEditorReady,
}) => {

	const handleModalClose = () => {
		setIsOpen(null);
	};

	const handleContinue = (e) => {
		handleSave(e)
	}

	return (
		<Modal
			open={isOpen}
			onClose={handleModalClose}
			maxWidth='lg'
			maxHeight='md'
			fullWidth
			{...modalProps}>
			<DialogTitle className='editSectionModal--DialogTitle'>
				<Typography type='s3' color='inherit' weight='medium'>
					Edit Content
				</Typography>
				<Box display='flex' alignItems={'center'} gap={1} position='absolute' right='1%' top='4px'>
					<Select
						displayEmpty
						value=''
						size='small'
						renderValue={() => 'Add placeholder'}
						fullWidth
						sx={{
							bgcolor: 'white',
							borderRadius: 1,
							'& .MuiSelect-select': { py: 0.75 }
						}}
						onChange={(e) => {
							if (e.target.value) {
								handleAddPlaceholder(e.target.value as string);
								e.target.value = '';
							}
						}}>
						{placeholders.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								<Typography type='s4' color='theme.secondary.1000'>{option.label}</Typography>
							</MenuItem>
						))}
					</Select>
					<IconButton onClick={handleModalClose}>
						<Close fontSize='small' />
					</IconButton>
				</Box>
			</DialogTitle>
			<DialogContent className='editSectionModal--DialogContents'>
				<Suspense>
					<CustomEditor handleEditorReady={handleEditorReady} data={section.content}/>
				</Suspense>
			</DialogContent>
			<DialogActions className='editSectionModal--DialogAction'>
				<Box display='flex' gap={1.5}>
					<Button className='editSectionModal--DialogAction--WhiteBtn' onClick={handleModalClose}>Cancel</Button>
					<Button onClick={(e) => handleContinue(e)}>Save</Button>
				</Box>
			</DialogActions>
		</Modal>
	);
};

export default EditSectionModal;
